import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
var index = 0;

function generateSafeId() {
  return "auic-".concat(index++);
}

function useSafeId(id) {
  var _React$useState = React.useState(function () {
    return generateSafeId();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      safeId = _React$useState2[0];

  return id || safeId;
}

export { useSafeId };